export default __webpack_public_path__ + "static/media/arrow.dae7c5e9.svg";